import { render, staticRenderFns } from "./TastePanelList.vue?vue&type=template&id=37bdd462&"
import script from "./TastePanelList.vue?vue&type=script&lang=js&"
export * from "./TastePanelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports